export enum NpsFeedbackQuestionSettings {
    HasFeedbackQuestion = "HasFeedbackQuestion",
    DefaultFeedbackQuestion = "DefaultFeedbackQuestion",
    FeedbackVariable = "FeedbackVariable",
    FeedbackAnswerRequired = "FeedbackAnswerRequired",
    PromotersFeedbackQuestion = "PromotersFeedbackQuestion",
    PromotersVariable = "PromotersVariable",
    PromotersAnswerRequired = "PromotersAnswerRequired",
    PassivesFeedbackQuestion = "PassivesFeedbackQuestion",
    PassivesVariable = "PassivesVariable",
    PassivesAnswerRequired = "PassivesAnswerRequired",
    DetractorsFeedbackQuestion = "DetractorsFeedbackQuestion",
    DetractorsVariable = "DetractorsVariable",
    DetractorsAnswerRequired = "DetractorsAnswerRequired",
}
export enum NpsScoresBySegment {
    PromotersScore = 9,
    DetractorsScore = 6,
}
